



































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, namespace } from 'vuex-class'
import { getEnvironments } from '@/environments'
import { MinutasPronosticoElementAPI } from '@/domain/entities/Api'
const env = getEnvironments()

const MINUTAS_PRONOSTICO = 'minutasPronostico'

@Component({
  components: {
  }
})
export default class DescargaPronostico extends Vue {
  @Getter('minutasPronostico', { namespace: MINUTAS_PRONOSTICO })
  minutasPronostico!: MinutasPronosticoElementAPI[]

  @Getter('linkDescarga', { namespace: MINUTAS_PRONOSTICO })
  linkDescarga!: string

  @Action('getMinutasPronostico', { namespace: MINUTAS_PRONOSTICO })
  getMinutasPronostico!: any

  @Action('getLinkDescarga', { namespace: MINUTAS_PRONOSTICO })
  getLinkDescarga!: any

  selectedDate: string = ''

  created () {
    this.getMinutasPronostico()
  }

  get isSelectedItems () {
    return this.selectedDate !== ''
  }

  async download () {
    await this.getLinkDescarga({ fecha: this.selectedDate })
    location.assign(this.linkDescarga)
  }

  get dates () {
    console.log(this.minutasPronostico)
    const selectedMinuta = this.minutasPronostico.find(pron => pron.fecha_list)
    console.log(selectedMinuta)
    if (selectedMinuta) {
      return selectedMinuta.fecha_list.map(fecha => ({ fecha }))
    }
    return [{ fecha: 'Error' }]
  }
}
